import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';
import { PayloadAction } from '@reduxjs/toolkit';

import AdminGateway from '~apis/admin';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { TCreateNewAdminReduxParams } from '~types/feat/admin';

import { ErrorMessages, SuccessMessages } from '~utils/constants';

export default function* watchCreateNewAdmin(api: AdminGateway): SagaWatcherReturnType {
    yield takeEvery('admin/adminCreateNewAdminAttempt', handleCreateNewAdmin, api);
}

function* handleCreateNewAdmin(api: AdminGateway, data: PayloadAction<TCreateNewAdminReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const response = yield* call([api, api.createNewAdmin], {
        authToken,
        ...data.payload,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.adminCreateNewAdminFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.adminCreateNewAdminSuccess());
        yield put(combinedActions.adminSetCreateNewAdminModalIsOpen(false));
        yield put(combinedActions.adminSetGetAdminListingIndex({ index: 0 }));
        yield put(combinedActions.adminGetAdminListingAttempt());

        toast.success(SuccessMessages.AdminCreateNewAdminSuccess);
    }
}
